const TabNotifications = () => {
   return (
      <div className="box">
         <div className="sub-content row clearfix">
            <div className="col-xs-12 col-sm-3 p-none">
               <h4 className="p-none">Email nhận thông báo</h4>
            </div>
            <div className="col-xs-12 col-sm-5 p-none">
               <div
                  className="input-text input-text-none-scrollbar text-single font-size-14 reply-message text-smaller h-40 display-flex">
                  <input type="text" placeholder="Nhập thông tin email" className="" value="" /></div><button
                     className="btn btn-default mt10">Lưu</button>
            </div>
         </div>
         <div className="sub-content row clearfix">
            <div className="col-xs-12 col-sm-3 p-none">
               <h4 className="p-none">Nhận thông báo Messenger</h4>
            </div>
            <div className="col-xs-12 col-sm-5 p-none">
               <div className="fb-send-to-messenger fb_iframe_widget" messenger_app_id="363772567412181" page_id="301937492992078"
                  data-ref="__hrf_s_oi_mf200002309455__1714458449_" color="blue" size="xlarge" cta_text="SUBSCRIBE"
                  fb-xfbml-state="rendered"
                  fb-iframe-plugin-query="app_id=363772567412181&amp;color=blue&amp;container_width=602&amp;cta_text=SUBSCRIBE&amp;locale=en_US&amp;messenger_app_id=363772567412181&amp;page_id=301937492992078&amp;ref=__hrf_s_oi_mf200002309455__1714458449_&amp;sdk=joey&amp;size=xlarge">
                  <span style={{ verticalAlign: 'bottom', width: 112, height: 37 }}><iframe name="f9354fb681bab0410"
                     width="1000px" height="1000px" data-testid="fb:send_to_messenger Facebook Social Plugin"
                     title="fb:send_to_messenger Facebook Social Plugin" frameborder="0" allowtransparency="true"
                     allowfullscreen="true" scrolling="no" allow="encrypted-media"
                     src=""
                     style={{ border: 'none', visibility: 'visible', width: 112, height: 37 }} className=""></iframe></span></div>
            </div>
            <div className="col-xs-12 col-sm-1 p-none"></div>
            <div className="col-xs-12 col-sm-3 p-none"><span className="note">Opt-in vào Bot của bạn để có thể lấy các thông báo trong
               Messenger và để thử nội dung Bot.</span></div>
            <div className="col-xs-12 col-sm-1 p-none"></div>
         </div>
      </div>
   )
}

export default TabNotifications;